import { AnimatedSection, GlowCard, GlassGlow, NoiseTexture } from "../shared";
import { IconTrend, IconProcessor, IconShield } from "../shared/icons";

const MARKET_STATS = [
  {
    value: "$28.5B",
    label: "Autonomous AI Market by 2028",
    icon: <IconTrend />,
  },
  {
    value: "$1.3T",
    label: "Generative AI & Agent Economy by 2032",
    icon: <IconProcessor />,
  },
  {
    value: "$40B",
    label: "Privacy-Preserving AI Market by 2035",
    icon: <IconShield />,
  },
] as const;

export function MarketOpportunity() {
  return (
    <section className="py-12 md:py-16 px-6 relative overflow-hidden">
      <NoiseTexture />
      <div className="absolute inset-0 bg-gradient-to-b from-[#0a0a0a] via-[#0d0d12] to-[#0a0a0a]" />
      <div className="absolute inset-0 bg-[radial-gradient(ellipse_50%_40%_at_50%_50%,_rgba(100,100,200,0.04),_transparent)]" />

      <div className="max-w-7xl mx-auto w-full relative z-10">
        <AnimatedSection>
          <div className="max-w-3xl mb-12">
            <span className="inline-flex items-center gap-2.5 text-[11px] font-semibold tracking-[0.2em] uppercase text-white/35 mb-5 before:content-[''] before:w-5 before:h-px before:bg-gradient-to-r before:from-violet-500/60 before:to-transparent">
              Market Opportunity
            </span>
            <h2 className="font-space-grotesk text-4xl md:text-6xl font-bold tracking-[-0.03em] leading-[1.1] gradient-text-dark">
              Meet The Autonomous Economy
            </h2>
            <p className="text-lg text-white/55 mt-6 leading-relaxed max-w-2xl">
              The internet is transitioning from manual interaction to
              autonomous execution. As capital aggressively rotates into AI
              agents, the demand for sovereign, privacy-first infrastructure is
              exploding. AGNT.Hub provides the foundational layer for this
              shift, positioned perfectly at the intersection of three
              exponentially growing markets to:
            </p>
          </div>
        </AnimatedSection>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
          {MARKET_STATS.map((item, i) => (
            <AnimatedSection key={item.value} delay={i * 0.12}>
              <GlowCard className="h-full bg-[#111] border border-white/[0.06] p-10 rounded-2xl transition-all duration-500 group cursor-default hover:border-white/[0.1]">
                <GlassGlow intensity={0.09} size={60} />
                <NoiseTexture />
                <div className="relative z-10">
                  <div className="text-white/30 mb-5">{item.icon}</div>
                  <div className="font-space-grotesk text-4xl md:text-5xl  font-bold mb-4 tracking-tight gradient-text-dark">
                    {item.value}
                  </div>
                  <p className="text-white/55 font-medium text-base leading-relaxed">
                    {item.label}
                  </p>
                </div>
              </GlowCard>
            </AnimatedSection>
          ))}
        </div>
      </div>
    </section>
  );
}

export default MarketOpportunity;
